import { Box } from "@mui/material";
import GlassCard from "../dashboard/GlassCard";

const FilterBar = ({ children, sx = {} }) => (
  <GlassCard hover={false} sx={{ mb: 2.5, p: 2, ...sx }}>
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(12, minmax(0, 1fr))" }, gap: 2 }}>
      {children}
    </Box>
  </GlassCard>
);

export default FilterBar;

